import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import DisplayAdsFormatFilter from "../../components/filters/DisplayAdsFormatFilter/DisplayAdsFormatFilter";
import DisplayAdsFormatFilterResult from "../../components/filters/DisplayAdsFormatFilter/DisplayAdsFormatFilterResult";
import { DisplayAdsFormatUpgradeView } from "../../components/filters/DisplayAdsFormatFilter/DisplayAdsFormatUpgradeView";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindDisplayAdsFormatFilter from "./DisplayAdsFormatFilter";

export const displayAdsFormatDefinition = defineDescriptionFilter({
    key: "displayAdsFormat",
    apiCategory: leadsFilterApiCategory.displayAdsFormat,
    category: leadsFilterCategoryMap.advertiserActivity,
    trackingName: "Display Ads Format",
    titleKey: { key: "si.lead_gen_filters.display_ads_format.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.display_ads_format.tooltip" },
        filter: new FindDisplayAdsFormatFilter({
            options: {
                displayAdsShare: description.adIntelligence.displayAdsShare,
            },
        }),
        filterView: DisplayAdsFormatFilter,
        filterResultView: DisplayAdsFormatFilterResult,
        gateStatus: !salesSettingsHelper.isSIAdIntelligenceEnabled
            ? { type: "upgrade", view: DisplayAdsFormatUpgradeView }
            : undefined,
    }),
});
